// services/personal.service.ts
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { AppliedLeave } from '../store/applied-leave/applied-leave.state'
import { eps } from './url.service'

@Injectable({ providedIn: 'root' })
export class AppliedLeaveService {
  private apiUrl = eps.leaves.appliedLeaveApi

  constructor(private http: HttpClient) {}

  getAppliedLeaves(
    params: string | null,
    page: number | null | undefined,
    limit: number | null | undefined
  ): Observable<{ totalCount: number; appliedLeaves: AppliedLeave[] }> {
    const url = params
      ? `${this.apiUrl}?${params}&page=${page}&limit=${limit}`
      : `${this.apiUrl}?page=${page}&limit=${limit}`
    return this.http.get<any>(url)
  }

  createAppliedLeave(payload: any): Observable<any> {
    return this.http.post(`${this.apiUrl}`, payload)
  }

  updateAppliedLeave(id: string, payload: any): Observable<AppliedLeave> {
    return this.http.put<AppliedLeave>(`${this.apiUrl}/${id}`, payload)
  }
}
